<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryOptions, enlarged, zoomLevel, minZoom, maxZoom, zoomIn, zoomOut, zoomReset } = useUiMediaGallery(props.name)
</script>

<template>
  <LazyUiDialog
    class="media-gallery-fullscreen"
    :class="{ 'media-gallery-fullscreen--enlarged': enlarged }"
    :name="props.name"
    dialog-type="fullscreen"
    @close="zoomReset"
  >
    <div class="media-gallery-fullscreen__container">
      <UiMediaGalleryMain
        :name="props.name"
        class="media-gallery-fullscreen__main"
      />

      <LazyUiMediaGalleryNavigation
        v-if="galleryOptions?.fullscreenOptions?.navigation"
        :name="props.name"
        class="media-gallery-fullscreen__navigation"
      >
        <template #gallery-prev-icon>
          <slot name="gallery-prev-icon" />
        </template>

        <template #gallery-next-icon>
          <slot name="gallery-next-icon" />
        </template>
      </LazyUiMediaGalleryNavigation>

      <UiMediaGalleryThumbs
        v-if="galleryOptions?.fullscreenOptions?.thumbs"
        :name="props.name"
        class="media-gallery-fullscreen__thumbs"
        :thumbs-trigger="galleryOptions?.fullscreenOptions?.thumbsTrigger"
      >
        <template #thumbs-prev-icon>
          <slot name="thumbs-prev-icon" />
        </template>

        <template #thumbs-next-icon>
          <slot name="thumbs-next-icon" />
        </template>
      </UiMediaGalleryThumbs>

      <UiMediaGalleryDots
        v-if="galleryOptions?.fullscreenOptions?.dots"
        :name="props.name"
        class="media-gallery-fullscreen__dots"
      />

      <UiMediaGalleryXofY
        v-if="galleryOptions?.fullscreenOptions?.XofY"
        :name="props.name"
        class="media-gallery-fullscreen__x-of-y"
      >
        <template #divider>
          /
        </template>
      </UiMediaGalleryXofY>

      <div class="media-gallery__zoom-controls zoom-controls">
        <button
          class="zoom-controls__zoom-in"
          :disabled="zoomLevel >= maxZoom"
          @click="zoomIn"
        >
          <NuxtIcon name="icon:zoom-in-large" />
        </button>

        <button
          class="zoom-controls__zoom-out"
          :disabled="zoomLevel <= minZoom"
          @click="zoomOut"
        >
          <NuxtIcon name="icon:zoom-out-large" />
        </button>
      </div>
    </div>
  </LazyUiDialog>
</template>

<style>
@import url("~layers/components/Ui/MediaGallery/Fullscreen.css");
</style>
